import { render, staticRenderFns } from "./BoardSetting.vue?vue&type=template&id=ef1970dc&scoped=true&"
import script from "./BoardSetting.vue?vue&type=script&lang=ts&"
export * from "./BoardSetting.vue?vue&type=script&lang=ts&"
import style0 from "./BoardSetting.vue?vue&type=style&index=0&id=ef1970dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef1970dc",
  null
  
)

export default component.exports